<section class="content">
  <div class="title-container">
    <h1 class="title">Alimentação Escolar</h1>
    <h2 class="subtitle">Insira os parâmetros para custeio da alimentação escolar.</h2>
  </div>

  <hr class="division-line"/>

  <div class="panel dropdown-panel">
    <app-menu-suspenso
      #menuTooltip="matTooltip"
      [matTooltip]="menuTooltipVisible ? 'Visualizar o PQR' : ''"
      matTooltipPosition="above"
      (chamadaDeAcao)="chamarAcao($event)"
      [opcoes]="[
        {
          rotulo: 'PQR desta funcionalidade',
          icone: 'computer',
          acao: 'pqrDestaFuncionalidade'
        },
        {
          rotulo: 'Restaurar valores com base no PQR',
          icone: 'content_copy',
          acao: 'restaurarValoresComBaseNoPqr'
        },
        {
          rotulo: 'PQR completo em nova aba',
          icone: 'desktop_windows',
          acao: 'pqrCompletoEmNovaAba'
        }
      ]"
    >
      Padrão de qualidade de referência (PQR)
    </app-menu-suspenso>

    <mat-icon
      class="info-icon"
      #infoTooltip="matTooltip"
      matTooltip="Informações sobre o PQR"
      matTooltipPosition="left"
      (mouseenter)="openTooltips()"
      (mouseleave)="closeTooltips()"
    >
      info
    </mat-icon>
  </div>

  <div class="panel">
    <app-tabela
      ngSkipHydration
      class="table-component"
      [cabecalhoCustomizado]="true"
    >
      <ng-container cabecalho>
        <tr>
          <th class="table-header" rowspan="2" style="width: 16%">Etapa/Modalidade</th>
          <th class="table-header" colspan="2" style="width: 16%">Número de matrículas</th>
          <th class="table-header" colspan="2" style="width: 16%">Número de matrículas indígenas e quilombolas</th>
        </tr>
        <tr>
          <th class="table-header" style="width: 3%">Parcial</th>
          <th class="table-header" style="width: 3%">Integral</th>
          <th class="table-header" style="width: 3%">Parcial</th>
          <th class="table-header" style="width: 3%">Integral</th>
        </tr>
      </ng-container>
      <ng-container corpo>
        <ng-container *ngFor="let dados of dadosMatriculaTabela; index as i">
          <tr>
            <td class="table-cell align-left">{{ dados.etapa}}</td>
            <td class="table-cell align-right">
              {{ dados.parcial | number }}
            </td>
            <td class="table-cell align-right">
              {{ dados.integral | number }}
            </td>
            <td class="table-cell align-right">
              {{ dados.parcialIndigena | number }}
            </td>
            <td class="table-cell align-right">
              {{ dados.integralIndigena | number }}
            </td>
          </tr>
        </ng-container>
      </ng-container>
    </app-tabela>
  </div>

  <div class="panel">
    <app-tabela
      ngSkipHydration
      class="table-component"
      [cabecalhoCustomizado]="true"
    >
      <ng-container cabecalho>
        <tr>
          <th class="table-header" rowspan="2" style="width: 16%">Etapa/segmento/modalidade</th>
          <th class="table-header" rowspan="2" colspan="1" style="width: 5%">Número de dias letivos</th>
          <th class="table-header" colspan="2" style="width: 25%">Per Capita (R$)</th>
          <th class="table-header" colspan="2" style="width: 25%">Per Capita (R$) (Indígenas e Quilombolas)</th>
        </tr>
        <tr>
          <th class="table-header" style="width: 3%">Parcial</th>
          <th class="table-header" style="width: 3%">Integral</th>
          <th class="table-header" style="width: 3%">Parcial</th>
          <th class="table-header" style="width: 3%">Integral</th>
        </tr>
      </ng-container>
      <ng-container corpo>
        <ng-container *ngFor="let dados of dadosTabela; index as i">
          <tr *ngIf="i % 2 === 0">
            <td class="table-cell align-left">{{ dados.etapaEnsino.descricao }}</td>
            <td class="table-cell align-right">{{ dados.numeroDiasLetivosAno }}</td>
            <td class="table-cell">
              <input
                class="display-input align-right text-green"
                [(ngModel)]="dados.valorRefeicao"
                (ngModelChange)="atualizarDadosDoServicoDeEstado()"
                appPtBrNumber
              />
            </td>

            <td class="table-cell">
              <input
                class="display-input align-right text-green"
                *ngIf="i !== 10"
                [(ngModel)]="dadosTabela[i+1].valorRefeicao"
                (ngModelChange)="atualizarDadosDoServicoDeEstado()"
                appPtBrNumber
              />
            </td>

            <td class="table-cell">
              <input
                class="display-input align-right text-green"
                [(ngModel)]="dados.valorRefeicaoIndigenaQuilombola"
                (ngModelChange)="atualizarDadosDoServicoDeEstado()"
                appPtBrNumber
              />
            </td>

            <td class="table-cell">
              <input
                class="display-input align-right text-green"
                *ngIf="i !== 10"
                [(ngModel)]="dadosTabela[i+1].valorRefeicaoIndigenaQuilombola"
                (ngModelChange)="atualizarDadosDoServicoDeEstado()"
                appPtBrNumber
              />
            </td>
          </tr>
        </ng-container>
      </ng-container>
    </app-tabela>
  </div>
</section>
